import React, {useContext, useMemo} from 'react';
import {PlayerContext} from "../../../shared/contexts/playerContext";
import {AuthContext} from "../../../shared/contexts/authContext";
import {useItemKrTextData} from "../../probability/useItemData";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import dayjs from "dayjs";
import LogTemplate from "../../logs/LogTemplate";
import {getLuckyArcadeLogColumns} from "../../logs/columns/luckyArcadeLogColumns";

const PlayerLuckyArcadeLog = () => {
    const { playerData } = useContext(PlayerContext);
    const { currentUser } = useContext(AuthContext);

    const { data: krItemTextData, isLoading, error } = useItemKrTextData();

    const defaultSearchParams = {
        begin: dayjs().subtract(3, 'month').startOf('day').unix(),
        end: dayjs().endOf('day').unix(),
        pid: playerData.pid,
        logType: 'RQLuckyArcadeLog',
        isUnix: true
    };

    const columns = useMemo(() => getLuckyArcadeLogColumns(krItemTextData, currentUser), [krItemTextData, currentUser]);

    if (isLoading) return <IsLoading />;
    if (error) return <ErrorPage error={error} />;

    return (
        <div>
            <LogTemplate
                columns={columns}
                defaultSearchParams={defaultSearchParams}
                routerUrl={'/logs/operation'}
                logName={'LuckyArcadeLog'}
                log={'operation'}
            />
        </div>
    );
};

export default PlayerLuckyArcadeLog;
